import { CardBackgroundUpdateService } from '../card/card-background-update.service';
import { DisplayIconFactory } from './display-icon-factory.interface';
import { ClimateControlStates, IDisplayInfoIcon } from '@caslink/device-client/ng-app/shared/models/types';
import { ICardDataViewModel } from '@caslink/device-client/ng-app/shared/models/models';

export class ClimateControlSensorDisplayIconFactory implements DisplayIconFactory {
    constructor(private cardBackgroundChangeService: CardBackgroundUpdateService) {}

    public createDisplayIcon(item: ICardDataViewModel): IDisplayInfoIcon {
        if (this.cardBackgroundChangeService) {
            this.cardBackgroundChangeService.backgroundChangeEvent.emit(item);
        }

        let materialIcon = null;
        if (item.displayValue === ClimateControlStates.HEATING) {
            materialIcon = 'wb_sunny';
        } else if (item.displayValue === ClimateControlStates.COOLING) {
            materialIcon = 'ac_unit';
        }

        const conditionalCls = [];
        if (!materialIcon) {
            conditionalCls.push({
                cls: 'rotating',
                condition: () => !!item.actualValue
            });

            conditionalCls.push({
                cls: 'fan-color',
                condition: () => true
            });
        }

        return {
            conditionalCls,
            getLabelText: () => item.displayValue || item.name,
            icon: materialIcon ? null : 'monitoringFan',
            materialIcon,
            isLabelVisible: () => true,
            getValue: () => item.value
        };
    }
}
